import type React from 'react'
import type { IconProps } from '@/types'

export const MobileFreeIcon: React.FC<IconProps> = ({ className = 'h-5 w-5', size }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      height={size}
      width={size}
    >
      <title>Mobile Free</title>
      <path
        d="m12.37 22.54 0.01 0.007a4.5 4.5 0 0 0 5.6 -0.615l0.629 -0.629a1.5 1.5 0 0 0 0 -2.122l-2.653 -2.651a1.5 1.5 0 0 0 -2.122 0h0a1.5 1.5 0 0 1 -2.121 0l-4.242 -4.243a1.5 1.5 0 0 1 0 -2.121h0a1.5 1.5 0 0 0 0 -2.122L4.819 5.393a1.5 1.5 0 0 0 -2.121 0l-0.63 0.629a4.5 4.5 0 0 0 -0.614 5.6l0.006 0.01A40.606 40.606 0 0 0 12.37 22.54Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="m23.25 2.25 -6 6 -7.5 -7.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="m9.75 5.25 0 -4.5 4.5 0"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}
